import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController, LoadingController, AlertController } from '@ionic/angular';
import { AvatarService } from '../services/avatar.service';

@Component({
  selector: 'app-driver-documents',
  templateUrl: './driver-documents.component.html',
  styleUrls: ['./driver-documents.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class DriverDocumentsComponent implements OnInit {
  @Input() info: any;
  records: any[] = [];
  isLoading: boolean = true;
  hasNoData: boolean = false;
  driverName: string = '';

  constructor(
    private chatService: AvatarService,
    public modalCtrl: ModalController,
    private loadingController: LoadingController,
    public alertController: AlertController
  ) { }

  ngOnInit(): void {
    this.driverName = this.info?.Driver_name || 'Driver';
    this.loadDocuments();
  }

  loadDocuments() {
    this.isLoading = true;
    if (!this.info?.Driver_id) {
      this.isLoading = false;
      this.hasNoData = true;
      return;
    }

    this.chatService.getDocument(this.info.Driver_id).subscribe({
      next: (docs: any[]) => {
        this.records = docs || [];
        this.hasNoData = this.records.length === 0;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading documents:', err);
        this.records = [];
        this.hasNoData = true;
        this.isLoading = false;
      }
    });
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  openDocument(url: string) {
    window.open(url, '_blank');
  }

  getDocumentIcon(type: string): string {
    switch (type) {
      case 'image':
        return 'image-outline';
      case 'pdf':
        return 'document-outline';
      case 'text':
      default:
        return 'document-text-outline';
    }
  }

  async approveDocument(doc: any) {
    const loading = await this.loadingController.create({ message: 'Authorizing...' });
    await loading.present();

    try {
      await this.chatService.UpdateDocumentStatus(this.info.Driver_id, doc.id, 'Approved');
      doc.status = 'Approved';
      const alert = await this.alertController.create({
        header: 'Protocol Verified',
        message: `${doc.name} has been successfully authorized.`,
        buttons: ['OK']
      });
      await alert.present();
    } catch (e) {
      console.error('Failed to approve document', e);
    } finally {
      loading.dismiss();
    }
  }

  async rejectDocument(doc: any) {
    const alert = await this.alertController.create({
      header: 'Deny Authorization',
      message: `Enter rejection reason for ${doc.name}:`,
      inputs: [{ name: 'reason', type: 'text', placeholder: 'Reason for rejection' }],
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Deny',
          handler: async (data) => {
            const loading = await this.loadingController.create({ message: 'Updating protocols...' });
            await loading.present();
            try {
              await this.chatService.UpdateDocumentStatus(this.info.Driver_id, doc.id, 'Rejected', data.reason);
              doc.status = 'Rejected';
            } catch (e) {
              console.error('Failed to reject document', e);
            } finally {
              loading.dismiss();
            }
          }
        }
      ]
    });
    await alert.present();
  }
  getStatusColor(status: string): string {
    switch (status) {
      case 'Approved':
        return 'success';
      case 'Pending':
        return 'warning';
      case 'Rejected':
        return 'danger';
      default:
        return 'medium';
    }
  }
}
